import { Input, Tooltip } from "antd";
import { type ChangeEvent } from "react";
import { useDataTableEditableColumn } from "~components/DataTable/hooks/useDataTableEditableColumn.ts";

type Props = {
  value?: string | null;
  isEditMode: boolean;
  disabled?: boolean;
  required?: boolean;
  onSave?: (value: string) => void | Promise<void>;
};

const getInitialValue = (value?: string | null) => value ?? "";
const isEmpty = (value: string) => !value.trim();

export const DataTableStringColumn = ({ value, isEditMode, disabled = false, required = false, onSave }: Props) => {
  const { inputValue, setInputValue, loading, errorMessage, clearErrorMessage, handleSave } =
    useDataTableEditableColumn({
      value,
      required,
      onSave,
      isEmpty,
      getInitialValue,
    });

  if (!isEditMode) {
    return value ?? "";
  }

  return (
    <Tooltip title={errorMessage} open={errorMessage ? true : undefined}>
      <Input
        disabled={disabled || loading}
        status={errorMessage ? "error" : undefined}
        style={{ width: "100%" }}
        value={inputValue}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          setInputValue(event.target.value);
          clearErrorMessage();
        }}
        onBlur={() => void handleSave()}
        onPressEnter={() => void handleSave()}
      />
    </Tooltip>
  );
};
